import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	mode: 'history',
	base: '/',
	routes: [
		{path: '/',redirect:'index1'},
		{path: '/index1',component:()=>import("./pages/index1.vue"),name:"首页"},
		{path: '/index2',component:()=>import("./pages/index2.vue"),name:"打卡页"},
	

		
	]
})